<template lang="">
	<div id="loading_wrapper">
		<div id="loading_mask" :style="{'filter': 'blur('+ this.bgBlur +'px)'}"></div>
		<div id="loading_info">
			<div id="loading_info_inner">
				<p id="info_title">{{this.mainTitle}}</p>
				<p id="info_percent">
					<span id="percent_num">{{this.loadingPercent}}</span>
					<span id="percent_sign">%</span>
				</p>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "LoadingMask",
	data() {
		return {
			mainTitle: this.data.carouselTitle,
		}
	},
	props: {
		data: {},
		bgBlur: {},
		loadingPercent: {}
	}
};
</script>

<style lang="scss">
#app_inner {
	
	&.isPageLoading {

		#loading_wrapper {
			visibility: visible;
			opacity: 1;

			#info_percent {
				opacity: 1;
			}
		}
	}

	#loading_wrapper {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		z-index: 200;
		visibility: hidden;
		transition: visibility 1s $transition_ease_in_out, opacity 0.5s 0.5s $transition_ease_in_out;

		#info_percent {
			opacity: 0;
			transition: opacity 0.5s $transition_ease_in_out;
		}
	}
}

@keyframes fade {
	99% {
		visibility: visible;
	}

	100% {
		visibility: hidden;
	}
}

#loading_mask {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	margin: -5px -10px -10px -5px;
	background-color: $gray_3;
	background-image: url("@/assets/images/loadingBg_1280x853.jpg");
	background-repeat: no-repeat;
	background-position: center;
    background-size: cover;
	transform: scale(1.1);

	@media (min-width: 1280px) {
		background-image: url("@/assets/images/loadingBg_1920x1280.jpg");
	}
}

#loading_info {
	display: flex;
	position: fixed;
	width: 100%;
	height: 100%;
	text-align: center;
	color: $white;
	z-index: 200;

	#loading_info_inner {
		margin: auto;
		align-self: center;

		#info_title {
			font-family: "Noto Serif TC", serif;
			margin-bottom: 24px;
			font-size: 32px;
			font-weight: $fw_regular;
			line-height: 1.25;
		}

		#info_percent {
			font-size: 16px;
			font-weight: $fw_medium;
			line-height: 1;
			

			#percent_num {
				display: inline-block;
				vertical-align: baseline;
				font-size: 24px;
				font-weight: $fw_light;
				line-height: 2;
			}

			#percent_sign {
				display: inline-block;
				vertical-align: baseline;
				margin-left: 3px;
			}
		}

		@media (min-width: 1024px) {

			#info_title {
				margin-bottom: 32px;
				font-size: 40px;
			}

			#info_percent {
				font-size: 20px;

				#percent_num {
					font-size: 32px;
				}
			}
		}

		@media (min-width: 1920px) {

			#info_title {
				margin-bottom: 40px;
				font-size: 56px;
			}

			#info_percent {
				font-size: 24px;

				#percent_num {
					font-size: 40px;
				}
			}
		}

		@media (min-width: 2560px) {

			#info_title {
				font-size: 80px;
			}

			#info_percent {
				font-size: 40px;

				#percent_num {
					font-size: 64px;
				}
			}
		}
	}
}
</style>